/**
 * Ingelogd + accountbeheerder (tenant-eerste beheerder of intern platform) — o.a. facturatie in het account.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, isAccountManager, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-text-muted">
        Laden…
      </div>
    );
  }

  if (!user?.authenticated) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  if (!isAccountManager) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
